import ReactMarkdown from 'react-markdown';

import { chatStyle } from './style';
import { getInputCommand } from './utils';

export type MessageUserProps = {
  message: string;
};

export function MessageUser({ message }: MessageUserProps) {
  const style = chatStyle();

  const command = getInputCommand(message);
  const processedMessage = command
    ? message.slice(command.length).trim()
    : message;

  if (!processedMessage) {
    return null;
  }

  return (
    <div className={style.messageUser()}>
      <ReactMarkdown>{processedMessage}</ReactMarkdown>
    </div>
  );
}
